var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalyticsPostSizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_611_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5544 24.7571H24.5919C24.404 24.7571 24.2563 24.6094 24.2563 24.4214V16.459C24.2563 15.7742 23.9609 15.1297 23.4506 14.6731C22.9404 14.23 22.269 14.0286 21.5976 14.1226C18.4288 14.5657 15.5419 16.3247 13.6755 18.943C11.7822 21.5882 11.0974 24.8511 11.7285 28.1005C12.6147 32.6927 16.3072 36.3852 20.8994 37.2714C21.6916 37.4191 22.4704 37.4997 23.2492 37.4997C25.693 37.4997 28.0562 36.7612 30.0569 35.3245C32.6752 33.4581 34.4342 30.5712 34.8773 27.4023C34.9713 26.7309 34.7699 26.0596 34.3268 25.5493C33.8837 25.0391 33.2258 24.7437 32.541 24.7437L32.5544 24.7571ZM28.9021 33.6998C26.7 35.2708 24.0011 35.8347 21.2888 35.311C17.4889 34.5725 14.4408 31.5245 13.7023 27.7246C13.1787 25.0122 13.7426 22.3133 15.3136 20.1112C16.8578 17.936 19.2478 16.4858 21.8796 16.1233C21.893 16.1233 21.9065 16.1233 21.9199 16.1233C22.0139 16.1233 22.081 16.1636 22.1213 16.2039C22.1616 16.2307 22.2422 16.3247 22.2422 16.459V24.4214C22.2422 25.7105 23.2895 26.7712 24.5919 26.7712H32.5544C32.7021 26.7712 32.7827 26.8518 32.8095 26.8921C32.8498 26.9458 32.9035 27.0263 32.8901 27.1338C32.5141 29.7521 31.064 32.1422 28.9021 33.6998Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4555 20.4077C36.7054 15.8371 33.1351 12.2669 28.5784 11.5306C27.8838 11.4194 27.1892 11.6139 26.6613 12.0724C26.1056 12.5447 25.8 13.2254 25.8 13.9478V20.7689C25.8 22.1025 26.8975 23.2 28.2311 23.2H35.0522C35.7746 23.2 36.4553 22.8805 36.9276 22.3387C37.3861 21.7969 37.5806 21.1023 37.4694 20.4216L37.4555 20.4077ZM35.33 20.9772C35.33 20.9772 35.205 21.1023 35.0522 21.1023H28.2311C28.0366 21.1023 27.8838 20.9495 27.8838 20.755V13.9478C27.8838 13.795 27.9811 13.6977 28.0089 13.67C28.0505 13.6283 28.12 13.6005 28.2034 13.6005C28.2172 13.6005 28.2311 13.6005 28.245 13.6005C31.9265 14.1979 34.8021 17.0735 35.3995 20.755C35.4134 20.8661 35.3717 20.9356 35.33 20.9911V20.9772Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_611_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsPostSizer);
export default __webpack_public_path__ + "static/media/analyticsPostSizer.6429c87c.svg";
export { ForwardRef as ReactComponent };